export interface Projects {
  projects: Project[];
}

export interface Project {
  id:              string;
  hero:            Hero;
  contentSections: ContentSection[];
  achievements:    Achievement[];
  technologies:    Technology[];
  callToAction:    CallToAction;
  meta:            Meta;
}

export interface Achievement {
  label:       string;
  value:       string;
  description: string;
}

export interface CallToAction {
  hasPublicDemo:              boolean;
  demoUrl?:                   string;
  contactMeUrl:               string;
  footerText:                 string;
  footerLinkTextPublic:       string;
  footerLinkTextConfidential: string;
  modalTitle?:                string;
  modalDescription?:          string;
  modalContactButton?:        string;
  modalCloseButton?:          string;
}

export interface ContentSection {
  title:          string;
  paragraphText:  string;
  contentImage:   string;
  imageAlignment: ImageAlignment;
}

export enum ImageAlignment {
  Left = "left",
  Right = "right",
}

export interface Hero {
  title:    string;
  subtitle: string;
  image:    string;
}

export interface Meta {
  timeframe: string;
  madeAt:    string;
}

export interface Technology {
  name: string;
}
